import SVImage from '@pkgs/shared-client/components/SVImage';
import SVPageMeta from '@apps/www/src/www/containers/SVPageMeta';
import SVButton from '@pkgs/shared-client/components/SVButton';
import SVLandingPageFooter from '@pkgs/shared-client/components/SVLandingPageFooter';
import SVPageHeader from '@pkgs/shared-client/components/SVPageHeader';
import SVPageMargins from '@pkgs/shared-client/components/SVPageMargins';
import SVPageTitle from '@pkgs/shared-client/components/SVPageTitle';
import extensionPreviewImage from '@pkgs/shared-client/img/extension-preview.png';
import firefoxIconPNG from '@pkgs/shared-client/img/firefox-icon.png';
import googleChromeIconPNG from '@pkgs/shared-client/img/google-chrome-icon.png';
import microsoftEdgeIconPNG from '@pkgs/shared-client/img/microsoft-edge-icon.png';
import safariIconPNG from '@pkgs/shared-client/img/safari-icon.png';

const extensionButtons: {
	link: string;
	icon: string;
	browserName: string;
}[] = [
	{
		link: 'https://chrome.google.com/webstore/detail/savee/hhefhkepfnmcgalemmofagaioeegonbc',
		icon: googleChromeIconPNG,
		browserName: 'Chrome',
	},
	{
		link: 'https://apps.apple.com/us/app/savee-for-safari/id1548320939?mt=12',
		icon: safariIconPNG,
		browserName: 'Safari',
	},
	{
		link: 'https://addons.mozilla.org/en-US/firefox/addon/savee/',
		icon: firefoxIconPNG,
		browserName: 'Firefox',
	},
	{
		link: 'https://microsoftedge.microsoft.com/addons/detail/savee/cieggpkfjghcpkknkenhpeaanadlpceg',
		icon: microsoftEdgeIconPNG,
		browserName: 'Edge',
	},
];

const SVExtensionPage = () => {
	const meta = {
		title: 'Extension',
	};

	return (
		<>
			<SVPageMeta {...meta} />

			<SVPageHeader className="mb-12">
				<SVPageTitle className="mb-2 type-small-title">
					Install our browser extension
				</SVPageTitle>
				<div className="text-gray-500">
					The easiest way save inspiration from any site. Just open the extension and we
					will scan the page for you.
				</div>
			</SVPageHeader>
			<SVPageMargins>
				<div className="flex flex-col items-center justify-center space-y-24">
					<div className="flex flex-wrap items-center justify-center w-full">
						{extensionButtons.map((button) => (
							<SVButton
								className="-md:my-1.5 mx-1.5 flex min-w-[170px] justify-start space-x-4 py-2 px-3"
								Component="a"
								href={button.link}
								target="_blank"
								rel="noopener noreferrer"
								key={button.browserName}
								icon={
									<SVImage src={button.icon} alt={button.browserName + ' icon'} />
								}
							>
								<div className="text-gray-200">{button.browserName}</div>
							</SVButton>
						))}
					</div>
					<SVImage
						src={extensionPreviewImage}
						alt="Extension preview"
						className="w-full max-w-[890px]"
					/>
				</div>
				<SVLandingPageFooter className="mt-40" />
			</SVPageMargins>
		</>
	);
};

export default SVExtensionPage;
